import React from "react"

const ListLoader = () => (<>
  <div style={{
    width: '90%',
    height: '44px',
    margin: '20px',
    borderRadius: '6px',
    background: 'rgba(0,0,0,.1)'}}>
  </div>
  <div style={{
    width: '90%',
    height: '44px',
    margin: '20px',
    borderRadius: '6px',
    background: 'rgba(0,0,0,.1)'}}>
  </div>
  <div style={{
    width: '90%',
    height: '44px',
    margin: '20px',
    borderRadius: '6px',
    background: 'rgba(0,0,0,.1)'}}>
  </div>
  <div style={{
    width: '90%',
    height: '44px',
    margin: '20px',
    borderRadius: '6px',
    background: 'rgba(0,0,0,.1)'}}>
  </div>
  <div style={{
    width: '90%',
    height: '44px',
    margin: '20px',
    borderRadius: '6px',
    background: 'rgba(0,0,0,.1)'}}>
  </div>
</>)

export default ListLoader
